import { Card, ListGroup } from 'react-bootstrap';
import React from "react";

const DSGVO = () => {
  return (
    <Card>
      <Card.Header as="h5">Datenschutz</Card.Header>
      <Card.Body>
        <Card.Text>
          Für Fragen zum Datenschutz in unserem Verein kannst du dich an unseren Datenschutzkoordinator wenden:
        </Card.Text>
        <ListGroup variant="flush">
          <ListGroup.Item><strong>TSC Stahl Hennigsdorf e.V.</strong></ListGroup.Item>
          <ListGroup.Item>Datenschutzkoordinator</ListGroup.Item>
          <ListGroup.Item>Jörg Schäfer</ListGroup.Item>
          <ListGroup.Item>Email: datenschutz[@]stahl-taucher.de</ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default DSGVO;

